module.exports = __webpack_public_path__ + "static/media/logo_DOTSC_small1.988a64d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_DOTSC_small1.png
// module id = 1075
// module chunks = 0